export default "__VITE_ASSET__cc4e7b4c__"